'use client';

import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { homeStore } from '@/infrastructure/store/homeStore';

export function useHome() {
  return useStore(
    homeStore,
    useShallow((s) => ({
      resumo: s.resumo,
      resumoLoading: s.resumoLoading,
      resumoFailed: s.resumoFailed,
      loadResumo: s.loadResumo,
    })),
  );
}
